import { z } from "zod";
import formErrors from "constants/formErrors";

const passwordSchema = z
  .string()
  .min(8, { message: formErrors.passwordMinLengthErrorMessage })
  .max(20, { message: formErrors.passwordMaxLengthErrorMessage })
  .refine((password) => /[A-Z]/.test(password), {
    message: formErrors.passwordUppercaseErrorMessage,
  })
  .refine((password) => /[a-z]/.test(password), {
    message: formErrors.passwordLowercaseErrorMessage,
  })
  .refine((password) => /[0-9]/.test(password), {
    message: formErrors.passwordNumberErrorMessage,
  })
  .refine((password) => /[^0-9a-zA-Z]/.test(password), {
    message: formErrors.passwordSpecialCharacterErrorMessage,
  });

export default passwordSchema;
